import { TrendingUp, TrendingDown, Minus } from "lucide-react";

// Tiny inline SVG sparkline for a per-route price trend. Red = creeping up, green = down.
export const Sparkline = ({ data = [], width = 60, height = 18, showDelta = true }) => {
  const points = (data || []).filter((v) => typeof v === "number" && !isNaN(v));

  if (points.length < 2) {
    return (
      <span className="text-[9px] text-slate-300" data-testid="rate-sparkline-empty">
        — no trend yet
      </span>
    );
  }

  const min = Math.min(...points);
  const max = Math.max(...points);
  const range = max - min || 1;
  const stepX = width / (points.length - 1);
  const coords = points.map((v, i) => [i * stepX, height - ((v - min) / range) * height]);
  const path = coords.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(" ");

  const first = points[0];
  const last = points[points.length - 1];
  const delta = last - first;
  const pct = first ? (delta / first) * 100 : 0;
  const up = delta > 0.005;
  const down = delta < -0.005;
  const color = up ? "#ef4444" : down ? "#16a34a" : "#94a3b8";
  const Icon = up ? TrendingUp : down ? TrendingDown : Minus;
  const [lx, ly] = coords[coords.length - 1];

  return (
    <span
      className="inline-flex items-center gap-1"
      data-testid="rate-sparkline"
      title={`R${first.toFixed(2)} → R${last.toFixed(2)} (${pct >= 0 ? "+" : ""}${pct.toFixed(1)}%) over ${points.length} checks`}
    >
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="overflow-visible">
        <polyline
          points={path}
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        <circle cx={lx} cy={ly} r="1.8" fill={color} />
      </svg>
      {showDelta && (
        <span className="inline-flex items-center gap-0.5 text-[9px] font-semibold" style={{ color }}>
          <Icon className="w-2.5 h-2.5" />
          {Math.abs(pct).toFixed(0)}%
        </span>
      )}
    </span>
  );
};

export default Sparkline;
